import { Outlet } from 'react-router-dom';

export default function RoleManagementLayout() {
    return (
        <Outlet />
    );
}
